/* eslint-disable react/prop-types */
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { useEffect, useState } from 'react';
import Check from './Check';
const stripePromise = loadStripe(
  'pk_test_51IULNyJIzDkeKMRYhLdIoiiFd6vNwSmzpNxZuLTLzdXqNDbcyZawbSwAT3FTQLaTlGPMHrDp8M2uvFKT0NdqSfjS00tHlucHGB'
);

const Stripe = (props) => {
  const [clientSecret, setClientSecret] = useState(null);
  const [paymentIntent, setPaymentIntent] = useState(null);
  useEffect(() => {
    fetch(
      'https://roc.work/stripe/?amount=' +
        localStorage.getItem('totalToPay') +
        '&firstname=' +
        localStorage.getItem('firstname') +
        '&lastname=' +
        localStorage.getItem('lastname') +
        '&phone=' +
        localStorage.getItem('phone') +
        '&email=' +
        localStorage.getItem('email')
    )
      .then((response) => response.json())
      .then((res) => {
        console.log(res);
        if (res.client_secret) {
          setClientSecret(res.client_secret);
          localStorage.setItem('customerId', res.customer_id);
          setPaymentIntent(res.id);
        }
      });
  }, []);

  const options = {
    clientSecret: clientSecret,
  };

  console.log(clientSecret);
  if (clientSecret) {
    return (
      <Elements stripe={stripePromise} options={options}>
        <Check onConfirm={() => props.onConfirm(paymentIntent, clientSecret)} />
      </Elements>
    );
  }
  return null;
};

export default Stripe;
